/**
 * The cleaner's photo link asking the listing server (MTR #599 part 2). The token is the only
 * credential; nothing is kept in the browser. Each call resolves to the server's answer and throws
 * only when no answer came back, in words she can act on.
 */
export function createCleanApi({ baseUrl, fetchImpl = null }) {
  const base = String(baseUrl ?? '').replace(/\/+$/, '')
  const go = fetchImpl ?? ((...a) => fetch(...a))
  const call = async (token, action, body) => {
    let res
    try {
      res = await go(`${base}/public/clean/${token}${action ? `/${action}` : ''}`, action
        ? { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body ?? {}) }
        : { method: 'GET' })
    } catch {
      throw new Error('No connection. Check your signal and try again.')
    }
    const out = await res.json().catch(() => null)
    if (res.status === 429) return { status: 'too_many_requests', says: 'Too many tries at once. Wait a minute and try again.' }
    if (res.status >= 500 || !out) return { status: 'internal_error', says: 'Something went wrong on our side. Try again.' }
    return out
  }
  return {
    open: (token) => call(token),
    mark: (token, item, status) => call(token, 'mark', { item, status }),
    finish: (token) => call(token, 'finish', {}),
    /* One photo: ask where to put it, send it there, then record it in the room. */
    async addPhoto(token, room, blob) {
      const where = await call(token, 'upload', { room, contentType: blob.type })
      if (where.status !== 'ok') return where
      let put
      try {
        put = await go(where.url, { method: 'PUT', headers: { 'content-type': blob.type, 'x-upsert': 'false' }, body: blob })
      } catch {
        throw new Error('The photo didn’t send. Check your signal and try again.')
      }
      if (!put.ok) return { status: 'upload_failed', says: 'The photo didn’t send. Try again.' }
      return call(token, 'photo', { room, path: where.path })
    },
  }
}
